export default __webpack_public_path__ + "UPt_profile.html";